import { render, staticRenderFns } from "./DateInputWidget.vue?vue&type=template&id=780cfbf3&"
import script from "./DateInputWidget.vue?vue&type=script&lang=ts&"
export * from "./DateInputWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports